import { boolean, object, string, type InferType } from "yup"
import { MachineSerialNumberSchema } from "../machines/MachineSerialNumber"

/**
 * The entry stroed in supabase.
 */
export const MachineTermsEntrySchema = object({
  user_id: string().required(),
  terms_version: string().required(),
  accept_date: string().required(),
  cancel_date: string().nullable(),
})

/**
 * The message sent from the AcceptTerms form to the backend. Also used for
 * linking a machine to the user's own org, which accepts the terms, too.
 *
 * Without the user: the backend takes it from the token.
 */
export const AcceptTermsSchema = object({
  machineSerialNumber: MachineSerialNumberSchema,
  termsVersion: string().required(),
  /**
   * Deliberately not stored with the terms: it is meant to trigger an action
   * (sharing with the dealer), see `DataActService.onTermsAccepted` in
   * backend/frontend-api. Not implemented yet.
   */
  shareWithDealer: boolean().default(false),
})

/**
 * The message sent from the CancelTerms form to the backend.
 *
 * Without the user: the backend takes it from the token.
 */
export const CancelTermsSchema = object({
  machineSerialNumber: MachineSerialNumberSchema,
  reason: string().trim().optional(),
})

export type MachineTermsEntryDto = InferType<typeof MachineTermsEntrySchema>
export type AcceptTerms = InferType<typeof AcceptTermsSchema>
export type CancelTerms = InferType<typeof CancelTermsSchema>

export const EuDataActTransferPastOrFutureList = ["past", "future"] as const
export const EuDataActTransferPastOrFutureSchema = string()
  .oneOf(EuDataActTransferPastOrFutureList)
  .defined()

export const EuDataActTransferSchema = object({
  userId: string().required(),
  pastOrFuture: EuDataActTransferPastOrFutureSchema.required(),
  dateOfTerms: string().required(),
  dateOfTransfer: string().required(),
  newUsersName: string().required(),
  newUsersAddress: string().required(),
  newUsersEmail: string().required(),
  newUsersPhone: string().required(),
  machineSerialNumber: string().required(),
  userName: string().required(),
  userAddress: string().required(),
  dateOfRequest: string().required(),
  // other, optional fields
  // reason: string().optional(),
  // isProcessed: boolean().optional().default(false),
})

export type EuDataActTransferDto = InferType<typeof EuDataActTransferSchema>

export const EuDataActDataSharingSchema = object({
  userId: string().required(),
  thirdPartysName: string().required(),
  thirdPartysAddress: string().required(),
  thirdPartysEmail: string().required(),
  thirdPartysPhone: string().required(),
  requestingName: string().required(),
  machineSerialNumber: string().required(),
  userNameAndAddress: string().required(),
  dateOfRequest: string().required(),
})

export type EuDataActDataSharingDto = InferType<
  typeof EuDataActDataSharingSchema
>

export const EuDataActRawDataSchema = object({
  userId: string().required(),
  requestingName: string().required(),
  requestedStartDate: string().required(),
  requestedEndDate: string().required(),
  machineSerialNumber: string().required(),
  userNameAndAddress: string().required(),
  dateOfRequest: string().required(),
})

export type EuDataActRawDataDto = InferType<typeof EuDataActRawDataSchema>
